<script>
	import { onMount } from 'svelte'
    import { store } from '../stores.js';
    import moment from 'moment';

	export let src;

	let loaded = false;
	let failed = false;
	let loading = false;

    const user = store('credentials', 'appUserAuth');
    const canvas = document.createElement('canvas');

	onMount(() => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = src;
        loading = true;

        img.onload = () => {
            if (loading) {
                loading = false;
                loaded = true;

                canvas.width = img.width;
                canvas.height = img.height;

                let ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);

                let drawText = (text, top, size = 50) => {
                    ctx.font = '300 ' + size + 'px sans-serif';
                    ctx.fillText(text, (canvas.width / 2) - (text.length * (size * .5) / 2), top);
                };
                let drawNomer = (text, top, size = 34) => {
                    ctx.font = '300 ' + size + 'px sans-serif';
                    ctx.fillText(text, (canvas.width / 10 * 7.63) - (text.length * (size * .5) / 2), top);
                };
                let drawData = (date, top, size = 34) => {
                    date = moment(date).format('DD.MM.YYYY');

                    ctx.font = '300 ' + size + 'px sans-serif';
                    ctx.fillText(date, (canvas.width / 10 * 6.4) - (date.length * (size * .5) / 2), top);
                };

				let ename = $$restProps['data-event-name'].replaceAll('&quot;', '"'),
					words = ename.split(' '),
					split = 8;
				
				if (words.length <= split) {
					drawText($$restProps['data-event-name'].replaceAll('&quot;', '"'), (canvas.height / 2) + 150, 60);
				} else {
					let size = Math.ceil(words.length / split) * 5;
					
					for (let i = 0; i < Math.ceil(words.length / split); i++) {
						drawText(words.slice(i * split, i * split + split).join(' '), (canvas.height / 2) + 120 + (i * 45), 60 - size);
					}
				}
				
                drawText('О том, что прошел (шла)', (canvas.height / 2) + 60);
                drawText($user.name, (canvas.height / 2) + 290);
                drawNomer($$restProps['data-nomer'], (canvas.height / 2) + 545);
                drawData($$restProps['data-event-date'], (canvas.height / 2) + 545);

                src = canvas.toDataURL('image/png');
            }
        };
        img.onerror = () => {
            loading = false;
            failed = true;
        };
	});
</script>

{#if loaded}
	<img {src} alt="Document" {...$$restProps} style="max-height: 660px; object-fit: contain;" />
{:else if failed}
	<img src="https://icon-library.com/images/not-found-icon/not-found-icon-20.jpg" alt="Not Found" />
{:else if loading}
	<img src="https://c.tenor.com/On7kvXhzml4AAAAi/loading-gif.gif" alt="Loading..." style="height: 100px;width: 100px;margin: 50px auto;" />
{/if}
